import {
    combineReducers,
    configureStore,
    createAction,
} from '@reduxjs/toolkit';
import {
    Action,
    PreloadedState,
    ThunkAction,
    createListenerMiddleware,
} from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import AdminReducer from '@Data/administration/Reducer';
import { BrowserPersistenceApi } from '@Data/browserPersistence/Api';
import BrowserPersistenceReducer from '@Data/browserPersistence/Reducer';
import DepartmentReducer from '@Data/departments/Reducer';
import EntityReducer from '@Data/entities/Reducer';
import FilesReducer from '@Data/files/Reducer';
import FolderReducer from '@Data/folders/Reducer';
import NotificationReducer from '@Data/notifications/Reducer';
import OrganizationReducer from '@Data/organizations/Reducer';
import ProcessReducer from '@Data/processes/Reducer';
import ProjectReducer from '@Data/projects/Reducer';
import QualityControlReducer from '@Data/qualityControl/Reducer';
import SettingsReducer from '@Data/settings/Reducer';
import TeamReducer from '@Data/teams/Reducer';
import UserReducer from '@Data/users/Reducer';
import WorkbenchReducer from '@Data/workbenches/Reducer';
import AutomationTaskReducer from '@Services/iiq/Reducer';
import { PersistenceConfig, loadState, saveState } from './Persistence';
import { initializeListeners } from './listeners';

const rootReducer = combineReducers({
    project: ProjectReducer,
    files: FilesReducer,
    process: ProcessReducer,
    automationTasks: AutomationTaskReducer,
    team: TeamReducer,
    folder: FolderReducer,
    entity: EntityReducer,
    notification: NotificationReducer,
    workbench: WorkbenchReducer,
    user: UserReducer,
    organization: OrganizationReducer,
    admin: AdminReducer,
    department: DepartmentReducer,
    settings: SettingsReducer,
    qualityControl: QualityControlReducer,
    browserPersistence: BrowserPersistenceReducer,
});

const listenerMiddleware = createListenerMiddleware();

let enhancers_array = [thunk];

if (!_isNil(process.env.DEBUG) && process.env.DEBUG == 'true') {
    let logger = null;
    logger = createLogger({ collapsed: true });
    enhancers_array.push(logger);
}

const store = configureStore({
    reducer: rootReducer,
    preloadedState: loadState(),
    enhancers: [applyMiddleware(...enhancers_array)],
    middleware: (getDefault) =>
        getDefault().prepend(listenerMiddleware.middleware),
    //enhancers: [applyMiddleware(thunk, logger)],
    // @ts-ignore
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;

let currentState = {};
store.subscribe(() => {
    // Only save if the persisted slices have changed
    const previousState = currentState;
    currentState = store.getState();

    const hasChanged = PersistenceConfig.slices.some(
        (sliceName) => currentState[sliceName] !== previousState[sliceName]
    );

    if (hasChanged) {
        saveState(currentState);
    }
});

initializeListeners(listenerMiddleware);

export default store;

export const setupStore = (preloadedState?: PreloadedState<any>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
    });
};
